import styled from 'styled-components';
import { media } from '@simplywallst/ui-core';
import { OneColumn } from '@components/Layout';

export const OneColumnExpanded = styled(OneColumn)`
  max-width: 1260px;
  &&& {
    padding-bottom: 76px;
    ${media.mdDown`
      padding-bottom: 0;
    `}
  }
`;
